import { useEffect, useState } from "react";

// non ideal implementation with state and use effect but
// the radxi checkbox somehow doesn't return the event and value in
// same function (seems odd, so will investigate later)
// if fix this can get rid of the state and use effect, and call
// handleMultipleSelect directly in the onChange of the checkbox
const useMultipleSelect = (table: any) => {
  const [currentSelectValue, setValue] = useState<any>(null);
  const [priorSelectValue, setPriorSelectValue] = useState<any>(null);
  const [shiftDown, setShiftDown] = useState(false);

  const setCurrentSelectValue = (value: any) => {
    setPriorSelectValue(currentSelectValue);
    setValue(value);
  };

  useEffect(() => {
    if (shiftDown && currentSelectValue) {
      const { row, value } = currentSelectValue;
      handleMultipleSelect(value, row);
      setValue(null);
      setShiftDown(false);
    }
  }, [currentSelectValue, shiftDown]);

  const handleMultipleSelect = (value: boolean, row: any) => {
    const rows = table.getRowModel().flatRows;
    const selectedRows = table.getSelectedRowModel().flatRows;

    const rowIndex = rows.findIndex((r: { id: any }) => r.id === row.id);

    if (rowIndex === -1) return;
    const priorSelectIndex = priorSelectValue
      ? rows.findIndex((r: { id: any }) => r.id === priorSelectValue?.row?.id)
      : -1;

    let highestLowerIndex = -1;
    let lowestHigherIndex = rows.length;

    selectedRows.forEach((selectedRow: { id: any }) => {
      const selectedRowIndex = rows.findIndex(
        (r: { id: any }) => r.id === selectedRow.id,
      );

      if (selectedRowIndex !== -1) {
        if (selectedRowIndex < rowIndex) {
          highestLowerIndex = Math.max(highestLowerIndex, selectedRowIndex);
        } else if (selectedRowIndex > rowIndex) {
          lowestHigherIndex = Math.min(lowestHigherIndex, selectedRowIndex);
        }
      }
    });

    // select up if prior select is higher than current
    if (priorSelectIndex !== -1 && priorSelectIndex > rowIndex) {
      for (let i = rowIndex; i <= priorSelectIndex; i++) {
        table.getRowModel()?.flatRows[i]?.toggleSelected(value);
      }
    }
    // select up if no lower selected
    else if (highestLowerIndex === -1 && lowestHigherIndex < rows.length) {
      for (let i = rowIndex; i <= lowestHigherIndex; i++) {
        table.getRowModel()?.flatRows[i]?.toggleSelected(value);
      }
    }
    // select down in all other cases
    else {
      if (value) {
        for (let i = highestLowerIndex; i <= rowIndex; i++) {
          table.getRowModel()?.flatRows[i]?.toggleSelected(value);
        }
      }
    }
  };

  return { setCurrentSelectValue, setShiftDown };
};

export default useMultipleSelect;
